import { type MutableRefObject,useEffect } from 'react';

export const useTabVisibleRaf = (rafRef: MutableRefObject<number>, tick: () => void) => {
    useEffect(() => {
        rafRef.current = requestAnimationFrame(tick);

        const handleVisibilityChange = () => {
            if (document.visibilityState !== 'visible') {
                return;
            }

            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }

            rafRef.current = requestAnimationFrame(tick);
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);

            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, [rafRef, tick]);
};
